import { GetterTree } from 'vuex';

import { State } from './state';

export const getters: GetterTree<State, State> = {
	onHome: s => s.currentRoutePath.includes('home'),
	onFilialfinder: s => s.currentRoutePath.includes('filialfinder'),
	isSearchVisible: s => !s.isAppView || s.isSearchToggled,
	displayFullPoiDetail: s => {
		// gibt zurück ob die Poi Informationen auf der kompletten Höhe des Detailfenster angezeigt wird
		// (dann wird normalerweise der Karten-Toggle ausgeblendet)

		// bei AppView muss noch zusätzlich auf den ViewMode geprüft werden
		// bei AppView == false ist es nur wichtig ob ein Marker selektiert wurde

		const isAppView = s.isAppView == true;
		const hasMarker = s.detailView?.selectedMarker != null;
		const viewModeIsFull = s.detailView?.mode == 'full';

		return (isAppView && hasMarker && viewModeIsFull) || (isAppView == false && hasMarker);
	}
};
